// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CourseCreationPage from './pages/CourseCreationPage';
import CourseDetailsPage from './pages/CourseDetailsPage';
import ChapterDetailsPage from './pages/ChapterDetailsPage';
import CourseStudentsPage from './pages/CourseStudentsPage';

import Announcements from './pages/Announcements';
import Calendar from './pages/Calendar';
import Certificates from './pages/Certificates';
import Payments from './pages/Payments';
import Exams from './pages/Exams';
import PostQuery from './pages/PostQuery';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import ElearningCommunityChat from './pages/ElearningCommunityChat';
import CreateExam from './pages/CreateExam';
import AutomaticExam from './pages/AutomaticExam';
import AutomaticExamTwo from './pages/AutomaticExamTwo';
import ICard from './pages/Icard';
import Community from './pages/Community';
import PaymentRegister from './pages/PaymentRegister';
import PaymentsPage from './pages/PaymentsPage';
import CreateAnnouncement from './pages/CreateAnnouncement';
import CreateEvent from './pages/CreateEvent';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



function RequireAuth({ children }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/community" element={<ElearningCommunityChat />} />
        <Route path="/create-exam" element={<CreateExam />} />
        <Route path="/automatic-exam" element={<AutomaticExam />} />
        <Route path="/automatic-exam-two" element={<AutomaticExamTwo />} />
        <Route path="/icard" element={<ICard />} />
        <Route path="/video-community" element={<Community />} />
        <Route path="/payment-register" element={<PaymentRegister />} />
        <Route path="/payments-page" element={<PaymentsPage />} />
        <Route path="/create-announcement" element={<CreateAnnouncement />} />
        <Route path="/create-event" element={<CreateEvent />} />
        
        

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <DashboardPage />
            </RequireAuth>
          }
        />
         <Route
          path="/dash"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/create-course"
          element={
            <RequireAuth>
              <CourseCreationPage />
            </RequireAuth>
          }
        />
        <Route
          path="/courses/:courseId/chapters"
          element={
            <RequireAuth>
              <CourseDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/courses/:courseId/chapters/:chapterId"
          element={
            <RequireAuth>
              <ChapterDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/courses/:id/students"
          element={
            <RequireAuth>
              <CourseStudentsPage />
            </RequireAuth>
          }
        />

        {/* Newly added student feature routes */}
        <Route
          path="/announcements"
          element={
            <RequireAuth>
              <Announcements />
            </RequireAuth>
          }
        />
        <Route
          path="/calendar"
          element={
            <RequireAuth>
              <Calendar />
            </RequireAuth>
          }
        />
        <Route
          path="/certificates"
          element={
            <RequireAuth>
              <Certificates />
            </RequireAuth>
          }
        />
        <Route
          path="/payments"
          element={
            <RequireAuth>
              <Payments />
            </RequireAuth>
          }
        />
        <Route
          path="/exams"
          element={
            <RequireAuth>
              <Exams />
            </RequireAuth>
          }
        />
        <Route
          path="/post-query"
          element={
            <RequireAuth>
              <PostQuery />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />

        {/* Catch-all fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
